export const parseIsoDate = (value: string | null | undefined): Date | null => {
	if (!value) return null;
	const parsed = new Date(value);
	return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const MONTH_YEAR_PATTERN = /^(?:(0[1-9]|1[0-2])\/)?(\d{4})$/;

export const parseMonthYear = (
	value: string | null | undefined,
): Date | null => {
	if (!value) return null;
	const match = MONTH_YEAR_PATTERN.exec(value);
	if (!match) return null;
	const month = match[1] ? Number(match[1]) - 1 : 0;
	const year = Number(match[2]);
	const parsed = new Date(year, month, 1);
	return Number.isNaN(parsed.getTime()) ? null : parsed;
};
